<template>
    <div>
        <swb-query-sort-area class="mb10" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>

        <div class="table-layout">
            <el-table ref="multipleTable" :data="merchtAccDefList" border tooltip-effect="dark" style="width: 100%" height="450" @selection-change="handleSelectionChange">
                <el-table-column width="40" align="center" type="selection" :selectable="selectable"></el-table-column>
                <el-table-column align="left" prop="accDef.name" label="配件名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.accDef.specificFlag">个</el-tag>
                        <span>{{scope.row.accDef.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="130" align="left" label="标签" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.merchantId != scope.row.accMerchantId">调拨</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="120" align="left" prop="accDef.modelSpec" label="规格" show-overflow-tooltip></el-table-column>
                <el-table-column width="60" align="center" prop="unit" label="单位">
                    <template slot-scope="scope">
                        <span>{{scope.row.accDef.unit}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="180" align="left" prop="accDef.catName" label="分类" show-overflow-tooltip></el-table-column>
                <el-table-column width="180" align="left" prop="accDef.brandName" label="品牌" show-overflow-tooltip></el-table-column>
                <el-table-column width="180" align="left" prop="accDef.modelSpec" label="规格" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" align="left" prop="accDef.creatorName" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" align="left" prop="accDef.memo" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" align="left" label="操作">
                    <template slot-scope="rows">
                        <span class="swb-btn swb-btn-link" @click="showAccStockInfo(rows.row.accDef.id)">查看库存</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import accStockApi from '../../api/accStock'

    import SwbAccStockListForAccDef from './AccStockListForAccDef'
    Vue.regist(SwbAccStockListForAccDef);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "配件名称",
            "code": "name",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "分类",
            "code": "catName",
            "basic": true,
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "品牌",
            "code": "brandName",
            "basic": true,
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "规格",
            "code": "modelSpec",
            "basic": true,
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "备注",
            "code": "memo",
            "basic": true,
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-mercht-acc-def-list-select',
        desc: '配件定义选择',
        props: {
            objectId: {
                type: Number
            },
            checkedIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                checked: true,
                merchtAccDefList: [],
                //
                queryConfig: searchConfigData || {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'multipleTable',
                checkedList: [],
            }
        },
        created: function () {
            let self = this;
            self.pageSize = self.pageSizes.first();

            self.checkedIdsX = self.checkedIds.clone();
            this.checkedIdsX.forEach(function (id) {
                let item = {};
                item.id = id;
                self.checkedList.add(item);
            });
            self.getAccDefList();
        },
        methods: {
            // ===================== 分页多选开始 ==============================
            addCheckId: function (id, val) {
                if(!this.checkedIdsX.contains(id)) {
                    this.checkedIdsX.add(id);
                    this.checkedList.add(val.accDef);
                    return id;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if(self.checkedIdsX.contains(id)) {
                    for(let i = 0; i < self.checkedList.length; i++) {
                        let checkedAccDef = self.checkedList[i];
                        if(checkedAccDef.id == id) {
                            self.checkedList.splice(i, 1);
                        }
                    }
                    self.checkedIdsX.remove(id);
                    return id;
                }
                return null;
            },

            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let allIds = self.merchtAccDefList.pluck("accId");
                let selIds = selRows.pluck("accId");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index]);
                });

                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "accId";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },

            hashCheckedId(id){
                return this.checkedIdsX.contains(id);
            },

            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "accId";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },

            // ===================== 分页多选结束 ==============================
            //===========回显禁用===============
            selectable: function (row, index) {
                let self = this;
                let checkedIds = self.checkedIds;
                if(checkedIds.indexOf(row.accDef.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            //===========回显禁用结束===============
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //
                this.getAccDefList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = val;
                this.getAccDefList();
            },
            getAccDefList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.merchantId = self.objectId || null;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                accStockApi.getMerchtAccDefListByMerchantId(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let resultData = result.data;
                        self.merchtAccDefList = resultData.rows;
                        //
                        self.totalCount = resultData.pagination.totalCount;
                        //
                        setTimeout(function () {
                            self.restoreSelRows(self.merchtAccDefList, self.checkedTblRefId, 'accId');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查看库存
            showAccStockInfo: function (accId) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '查看库存',
                    width: 900,
                    height: 820,
                    centerButtons: false,
                    showCloseBtn: true,
                    cancelVisible: false,
                    okVisible: false,
                    template: '<swb-acc-stock-list-for-acc-def :accId="accId" :merchantId="merchantId" ref="swb_acc_stock_list_for_acc_def"></swb-acc-stock-list-for-acc-def>',
                    data: {
                        merchantId: self.objectId,
                        accId: accId
                    },
                    okClicked: function () {
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let multipleSelection = self.checkedList;
                if(multipleSelection != null && multipleSelection.length > 0) {
                    result.type = 'info';
                    result.data = multipleSelection;
                } else {
                    result.type = 'warn';
                    result.message = '至少选择一个配件！';
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/shareAcc/MerchtAccDefSelect.vue